import {
  CREATE_MERCHANT_DEVICES_FAILURE,
  CREATE_MERCHANT_DEVICES_PENDING,
  CREATE_MERCHANT_DEVICES_SUCCESS,
  DELETE_MERCHANT_DEVICES_FAILURE,
  DELETE_MERCHANT_DEVICES_PENDING,
  DELETE_MERCHANT_DEVICES_SUCCESS,
  GET_MERCHANT_DEVICES_FAILURE,
  GET_MERCHANT_DEVICES_PENDING,
  GET_MERCHANT_DEVICES_SUCCESS,
  UPDATE_MERCHANT_DEVICES_FAILURE,
  UPDATE_MERCHANT_DEVICES_PENDING,
  UPDATE_MERCHANT_DEVICES_SUCCESS,
} from './actionTypes';
import { logToDatadog } from '../services/datadog';
import { MerchantDevice, MerchantDeviceCreationData } from '@m4a3/api-client/dist/models/merchant-device.interface';
import { orderfulApi } from '../services/api-instances';

export const getAllMerchantDevicesForCell = (cellId: number, pageSize = 200) => async dispatch => {
  dispatch({
    type: GET_MERCHANT_DEVICES_PENDING
  });
  try {
    const paginatedDevices = await orderfulApi.getMerchantDevicesByCellId(cellId, {size: pageSize});
    dispatch({
      type: GET_MERCHANT_DEVICES_SUCCESS,
      payload: paginatedDevices.entities
    });

  } catch (error) {
    logToDatadog('error_getting_merchant_devices', {cellId, pageSize, error});
    dispatch({
      type: GET_MERCHANT_DEVICES_FAILURE,
      payload: error
    });
  };
};

export const createMerchantDeviceForCell = (cellId: number, merchantDevice: MerchantDeviceCreationData) => async dispatch => {
  dispatch({
    type: CREATE_MERCHANT_DEVICES_PENDING
  });
  try {
    const device = await orderfulApi.createMerchantDeviceForCell(cellId, merchantDevice);
    dispatch({
      type: CREATE_MERCHANT_DEVICES_SUCCESS,
      payload: device
    });

  } catch (error) {
    logToDatadog('error_creating_merchant_devices', {cellId, merchantDevice, error});
    dispatch({
      type: CREATE_MERCHANT_DEVICES_FAILURE,
      payload: error
    });
  };
};

export const updateMerchantDevice = (cellId: number, merchantDeviceId: string, merchantDevice: MerchantDevice) => async dispatch => {
  dispatch({
    type: UPDATE_MERCHANT_DEVICES_PENDING
  });
  try {
    const device = await orderfulApi.updateMerchantDevice(cellId, merchantDeviceId, merchantDevice);
    dispatch({
      type: UPDATE_MERCHANT_DEVICES_SUCCESS,
      payload: device
    });

  } catch (error) {
    logToDatadog('error_updating_merchant_devices', {cellId, merchantDeviceId, merchantDevice, error});
    dispatch({
      type: UPDATE_MERCHANT_DEVICES_FAILURE,
      payload: error
    });
  };
};

export const deleteMerchantDeviceById = (cellId: number, merchantDeviceId: string) => async dispatch => {
  dispatch({
    type: DELETE_MERCHANT_DEVICES_PENDING
  });
  try {
    const device = await orderfulApi.deleteMerchantDeviceById(cellId, merchantDeviceId);
    dispatch({
      type: DELETE_MERCHANT_DEVICES_SUCCESS,
      payload: device
    });

  } catch (error) {
    logToDatadog('error_deleting_merchant_devices', {cellId, merchantDeviceId, error});
    dispatch({
      type: DELETE_MERCHANT_DEVICES_FAILURE,
      payload: error
    });
  };
};
